import baseUrl from "./BaseURL";
import { StringConstants } from "./StringConstants";

class UrlConstants extends StringConstants {
  url = baseUrl.url;

  timeout = "timeout";
  public = "public";
  auth = "auth";
  user = "user";
  profile = "profile";
  subscription = "subscription";
  invoice = "invoice";
  payment = "payment";
  dasha = "dasha";
  person = "person";
  astrology = "astro";
  notification = "notification";
  analysis = "analysis";
  twoPerson = "two-person";

  PUBLIC_URL = `${this.url}/${this.public}`;
  AUTH_URL = `${this.url}/${this.auth}`;
  USER_URL = `${this.url}/${this.user}`;
  SUBSCRIPTION_URL = `${this.url}/${this.subscription}`;
  INVOICE_URL = `${this.url}/${this.invoice}`;
  PAYMENT_URL = `${this.url}/${this.payment}`;
  DASHA_URL = `${this.url}/${this.dasha}`;
  PERSON_URL = `${this.url}/${this.person}`;
  ASTROLOGY_URL = `${this.url}/${this.astrology}`;
  NOTIFICATION_URL = `${this.url}/${this.notification}`;
  ANALYSIS_URL = `${this.url}/${this.analysis}`;
  TWO_PERSON_URL = `${this.url}/${this.twoPerson}`;

  loader1 = `${this.url}/public/loader-video-1`;
  loader2 = `${this.url}/public/loader-video-2`;

  // view-path
  homeViewPath = "/";
  loginViewPath = "/login";
  registerViewPath = "/register";
  resetPasswordViewPath = "/reset-password";
  setPasswordViewPath = "/set-password";
  dashboardViewPath = "/dashboard";
  professionAnalysisViewPath = "/profession-analysis";
  profileViewPath = "/profile";
  addDataViewPath = "/add-data";
  resumeViewPath = "/resume";
  calculateViewPath = "/calc";
  analysisViewPath = "/analysis";
  reportViewPath = "/report";
  generateReportViewPath = "/generate-report";
  missingMineralsViewPath = "/minerals";
  mahadashaViewPath = "/mahadasha";
  planetDetailsViewPath = "/planet-details";
  footballPredictionViewPath = "/football-position-prediction";
  nakshatraAnalysisViewPath = "/nakshatra-analysis";
  circularChartViewPath = "/circular-chart";
  pricingViewPath = "/pricing";
  paymentViewPath = "/payment";
  userProfileViewPath = "/my-profile";
  updatePasswordViewPath = "/update-password";
  subscriptionViewPath = "/subscription";
  successViewPath = "/success";
  failViewPath = "/fail";
  deleteAccountViewPath = "/delete-account";
  privacyPolicyViewPath = "/privacy-policy";
  vedazTalkViewPath = "/vedaz-talk";
  vedazChatViewPath = "/vedaz-chat";
  vedazCompatibilityViewPath = "/vedaz-talk/compatibility";
  compatibilityViewPath = "/two-person-compatibility";
  compatibilityAdminViewPath = "/compatibility-center";
  getReportViewPath = "/get-report";
  currentNakshatraViewPath = "/current-nakshatra";
  rahuTransitsViewPath = "/rahu-transits";
  userManagementViewPath = "/user-management";
  ragChatbotViewPath = "/rag-chatbot";
  settingsViewPath = "/settings";
  housesViewPath = "/houses";
  promocodeViewPath = "/promo-code";
  tasksViewPath = "/tasks";
  dataDownloadViewPath = "/data-download";
  productManagementViewPath = "/banners";
  arudhaPadaViewPath = "/arudha-pada";
  shadbalaViewPath = "/shadbala";
  karmicResourcesViewPath = "/karmic-resources";
  aspectsViewPath = "/aspects";
  aboutUsViewPath = "/about-us";
  aboutVedazViewPath = "/about-vedaz";
  timeAnalysisViewPath = "/time-analysis";
  professionPhasedViewPath = "/multi-ai-agents-analysis";
  astrocartographyViewPath = "/astrocartography";

  // apis

  //public
  loginUser = `${this.PUBLIC_URL}/login`;
  registerUser = `${this.PUBLIC_URL}/sign-up`;
  resetPassword = `${this.PUBLIC_URL}/reset-password`;
  tasksApi = `${this.PUBLIC_URL}/tasks`;
  bannersApi = `${this.PUBLIC_URL}/banners`;

  //auth
  verifyOtp = `${this.AUTH_URL}/verify-otp`;
  resendOtp = `${this.AUTH_URL}/resend-otp`;
  setPassword = `${this.AUTH_URL}/set-password`;
  logout = `${this.AUTH_URL}/logout`;
  getUsers = `${this.AUTH_URL}/get-users`;
  setUserStatus = `${this.AUTH_URL}/set-user-admin`;
  promocode = `${this.AUTH_URL}/promocode`;

  //user
  getUserProfile = `${this.USER_URL}/`;
  updateUserProfile = `${this.USER_URL}/`;
  updatePassword = `${this.USER_URL}/update-password`;
  getProfile = `${this.USER_URL}/${this.profile}/`;
  getProfileById = `${this.USER_URL}/${this.profile}`;
  addProfile = `${this.USER_URL}/${this.profile}/`;
  fetchDetails = `${this.url}/${this.person}/details/all`;
  getReport = `${this.url}/pdf/generate-pdf`;
  getFullReport = `${this.url}/pdf/generate-full-pdf`;
  getShortResume = `${this.url}/pdf/generate-short-pdf`;
  getFullResume = `${this.url}/pdf/generate-full-pdf-short`;
  exportPdf = `${this.url}/pdf/download-pdf`;
  deleteProfile = `${this.USER_URL}/${this.profile}/`;
  makeDefault = `${this.USER_URL}/${this.profile}`;
  updateProfile = `${this.USER_URL}/${this.profile}`;
  deleteAccount = `${this.USER_URL}/`;
  setLanguagePreference = `${this.USER_URL}/set-preference`;
  getPreference = `${this.USER_URL}/get-pref`;
  updatePreference = `${this.USER_URL}/update-pref`;
  migrateUser = `${this.USER_URL}/migrate-user`;
  favouriteUserChat = `${this.USER_URL}/favourite`;

  //subscription
  getPlans = `${this.SUBSCRIPTION_URL}/plan`;
  getSubscription = `${this.SUBSCRIPTION_URL}`;
  createSubscription = `${this.SUBSCRIPTION_URL}/`;
  updatePlan = `${this.SUBSCRIPTION_URL}/`;
  setPromoCode = `${this.SUBSCRIPTION_URL}/promocode`;
  cancelSubscription = `${this.SUBSCRIPTION_URL}/`;
  getPayPalUrl = `${this.SUBSCRIPTION_URL}/paypal-checkout`;
  getBlikUrl = `${this.SUBSCRIPTION_URL}/blik-checkout`;
  getP24Url = `${this.SUBSCRIPTION_URL}/p24-checkout`;
  getSuccessDetails = `${this.SUBSCRIPTION_URL}/success-details`;
  getUserSubscriptionDetails = `${this.SUBSCRIPTION_URL}/user`;

  //Report
  getReportData = `${this.url}/pdf/get-data`;
  getOtherData = `${this.url}/pdf/get-data-other`;
  addData = `${this.url}/pdf/add-data`;
  getPlanets = `${this.url}/pdf/get-keys`;
  addDataOther = `${this.url}/pdf/add-data-other`;

  //Resume
  fetchResumeDetails = `${this.url}/astro-resume`;

  //invoice
  getInvoices = `${this.INVOICE_URL}`;

  //payment
  getPaymentMethods = `${this.PAYMENT_URL}/`;
  addPaymentMethods = `${this.PAYMENT_URL}/`;
  makeDefaultPaymentMethod = `${this.PAYMENT_URL}`;
  deletePaymentMethod = `${this.PAYMENT_URL}`;

  //person
  analysisData = `${this.PERSON_URL}/analysis`;
  missingMinerals = `${this.PERSON_URL}/missing-minerals`;
  getMoonPhases = `${this.PERSON_URL}/moon-phase`;
  planetData = `${this.PERSON_URL}/details/planet`;
  individualPlanetData = `${this.PERSON_URL}/details/planet/individual`;
  individualHouseData = `${this.PERSON_URL}/details/house/individual`;
  footballPrediction = `${this.PERSON_URL}/football-prediction`;
  circularChart = `${this.PERSON_URL}/circular-chart-xiega`;
  choghadiya = `${this.PERSON_URL}/choghadiya`;
  fullChoghadiya = `${this.PERSON_URL}/full_choghadiya`;
  hora = `${this.PERSON_URL}/hora`;
  fullHora = `${this.PERSON_URL}/full_hora`;
  professionPrediction = `${this.PERSON_URL}/profession-prediction`;
  uploadFile = `${this.PERSON_URL}/upload_profession_csv`;
  rahuTranist = `${this.PERSON_URL}/rahu-transits`;
  currentNakshatra = `${this.PERSON_URL}/details/school`;
  dataDownloadApi = `${this.PERSON_URL}/data-download`;
  arudhaPada = `${this.PERSON_URL}/arudha-pada`;
  shadbala = `${this.PERSON_URL}/shadbala`;
  vedicAspects = `${this.PERSON_URL}/vedic-aspects`;
  timeAnalysis = `${this.PERSON_URL}/time-analysis`;
  professionAnalysis = `${this.PERSON_URL}/profession-analysis`;
  professionPhasedPhase = `${this.PERSON_URL}/profession-phased/phase`;
  professionPhasedPrompt = `${this.PERSON_URL}/profession-phased/prompts`;
  professionPhasedDownload = `${this.PERSON_URL}/profession-phased/download`;
  trueLookReport = `${this.url}/true-look/report`;
  trueTattooReport = `${this.url}/true-tattoo/report`;

  //astrocartography
  astrocartographyLines = `${this.url}/astrocartography/lines`;
  astrocartographyReport = `${this.url}/astrocartography/report`;
  astrocartographyFocusOptions = `${this.url}/astrocartography/focus-options`;

  //dasha
  mahadashaData = `${this.DASHA_URL}/mahadasha`;
  maleficDashaData = `${this.DASHA_URL}/malefic-occurrence-pattern`;
  beneficDashaData = `${this.DASHA_URL}/benefic-occurrence-pattern`;
  innerDashaCosmicData = `${this.DASHA_URL}/innerdasha-cosmic`;
  threePlanetChangeData = `${this.DASHA_URL}/three-planet-change`;
  threePlanetChangeLifeData = `${this.DASHA_URL}/three-planet-change-life`;
  pranadashaData = `${this.DASHA_URL}/pranadasha`;

  //notification
  notificationList = `${this.NOTIFICATION_URL}/`;
  notificationCount = `${this.NOTIFICATION_URL}/count`;

  //general
  buyNowUrl = `${this.ASTROLOGY_URL}/web-url`;
  contactUsApi = `${this.ASTROLOGY_URL}/contact-us`;

  //analysis
  professionCategories = `${this.ANALYSIS_URL}/analyse-profession-keys`;
  professionAttribute = `${this.ANALYSIS_URL}/analyse-profession-attribute-keys`;
  professionPredicationChart = `${this.ANALYSIS_URL}/analyse-profession`;

  //two-person
  compatibilityAllUser = `${this.TWO_PERSON_URL}/compatibility-all-user`;
  chatUserList = `${this.TWO_PERSON_URL}/chat-user-list`;
  matchUserList = `${this.TWO_PERSON_URL}/match-user-list`;
  favouriteUserList = `${this.TWO_PERSON_URL}/favourite-user-list`;
  compatibilityForUsers = `${this.TWO_PERSON_URL}/compatibility-for-users`;
  compatibilityForUsersProfiles = `${this.TWO_PERSON_URL}/compatibility-for-users-profile`;
  dailyProfiles = `${this.TWO_PERSON_URL}/daily-picks`;

  //rag apis
  ragUploadFileApi = `${this.url}/rag/upload`;
  ragAskApi = `${this.url}/rag/ask`;
  getDocuments = `${this.url}/rag/documents`;
  getSessions = `${this.url}/rag/session`;
  karmicResources = `${this.url}/pdf/karmic-resources`;
  karmicResourcesCustom = `${this.url}/pdf/karmic-resources-custom`;
}

let urls = new UrlConstants();
export default urls;
